import React from "react";
import GoogleImage from "assets/images/reviewImages/google.png";
import fb from "assets/images/reviewImages/fb.png";
import clutch from "assets/images/reviewImages/clutch.png";
import g2 from "assets/images/reviewImages/g2.png";
import goodfirms from "assets/images/reviewImages/goodfirms.png";
import tp from "assets/images/reviewImages/tp.png";
import featured from "assets/images/reviewImages/featured.png";

export default function Checkus() {
  return (
    <div>
      <div className="mainContainer bg-check-us py-[150px] bg-cover bg-no-repeat w-full">
        <div className="px-10 w-full flex flex-col lg:flex-row justify-center mx-auto">
          <h2 className="text-4xl flex mx-auto justify-center font-secondary font-semibold text-white text-center px-4 lg:px-0 w-full lg:w-[35%] leading-relaxed">
            Check us out in all our External Review Platforms
          </h2>
          <div className="cards flex mx-auto justify-center w-full lg:w-[65%] flex-wrap items-center flex-col lg:flex-row gap-x-6 pl-[5px] gap-y-6 sm:gap-y-2 xl:gap-y-6 lg:pt-0 pt-5">
            <a href="https://www.google.com/search?hl=en-PH&gl=ph&q=Tomedes+Translation+Services,+9450+SW+Gemini+Dr+%2334540,+Beaverton,+OR+97008,+United+States&ludocid=17077230497081966702&lsig=AB86z5XC3nTKyB_sSjS3gy-9ZeNd#lrd=0x54950d8bd3c5960d:0xecfe82a87609c06e,1" target="_blank">
              <img src={GoogleImage} alt="" />
            </a>
            <a href="https://www.goodfirms.co/company/tomedes" target="_blank">
              <img src={goodfirms} alt="" />
            </a>
            <a href="https://www.trustpilot.com/review/www.tomedes.com" target="_blank">
              <img src={tp} alt="" />
            </a>
            <a href to="https://www.facebook.com/Tomedes.translation/reviews" target="_blank">
              <img src={fb} alt="" />
            </a>
            <a href="https://clutch.co/profile/tomedes-1?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=num_reviews#reviews" target="_blank">
              <img src={clutch} alt="" />
            </a>
            <a href="https://www.featuredcustomers.com/vendor/tomedes" target="_blank">
              <img src={featured} alt="" />
            </a>
            <a href="https://www.g2.com/products/tomedes/reviews" target="_blank">
              <img src={g2} alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
